module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"capitalGrowthChart":"Pension Capital Growth"},"si":{"capitalGrowthChart":"Pension Capital Growth"},"ta":{"capitalGrowthChart":"Pension Capital Growth"}}')
  delete Component.options._Ctor
}
